<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <div class="personal-details">
        <div class="header-block">
          <div class="header-title">
            <app-breadcrumb></app-breadcrumb>
          </div>
          <div class="add-block">
            <div class="filter-icon">
              <i class="bi bi-arrow-clockwise" (click)="refreshMarker()"
                title="{{ 'generic.refresh' | translate }}"></i>
            </div>
          </div>
        </div>
        <div class="row map-block">
          <div class="col-md-8 col-lg-8" [ngClass]="{'col-lg-4 col-md-4': showFilter }">
            <div class="map-container" [ngClass]="[isFullscreen ? bi_fullscreen : '']">
              <div class="map-frame">
                <i class="bi bi-fullscreen" [ngClass]="isFullscreen ? 'bi-fullscreen-exit' : 'bi-fullscreen'"
                  (click)="toggleFullscreen()"></i>
                <div id="map">
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-lg-4" style="padding-left: 0;">
            <div class="customerList">

              <div class="list">
                <div class="locate-filter">
                  <p class="customer-check"><input [(ngModel)]="isCustomer" (click)="customerCheck()" type="checkbox">{{
                    'telco-customer-info.showCustomersOnly' | translate }}</p>
                  <button (click)="refreshMarker()">{{ 'generic.clear' | translate }}</button>
                </div>
                <p [ngClass]="{'is-checked': list.isChecked}" *ngFor="let list of locationList"
                  (click)="locationCheck(list,list.isChecked)">
                  <span></span>
                  {{list.zone}} - {{list.city}} - {{list.postalCode}}
                </p>
              </div>
              <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
              </div>

              <div class="loader" *ngIf="!isLoading && locationList.length == 0">
                <div class="no-data">
                  <img src="assets/no-data-6.png" alt="">
                  <p>{{ 'telco-customer-info.noDataFound' | translate }}</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>




<button [hidden]="true" id="view-detail" data-toggle="modal" data-target="#viewModal"></button>
<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'telco-customer-info.headings.liveDetails' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div>
          <div *ngFor="let list of telcoCustomerData" class="form-container">
            <!-- <h2>Telco Customer Form</h2> -->

            <!-- Basic Info -->
            <div class="section">
              <div class="row">
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>{{ 'telco-customer-info.customerName' | translate }}:</label>
                    <p>{{list.customerName || " -- "}}</p>
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>{{ 'telco-customer-info.customerEmailId' | translate }}:</label>
                    <p>{{list.customerEmailId || " -- "}}</p>
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>{{ 'telco-customer-info.customerPhoneNumber' | translate }}:</label>
                    <p>{{list.customerPhoneNumber || " -- "}}</p>
                  </div>
                </div>

                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>{{ 'telco-customer-info.customerLocation' | translate }}:</label>
                    <p>{{list.customerLocation || " -- "}}</p>
                  </div>
                </div>

                <div class="col-md-6 col-lg-6" *ngIf="list.customerBranch">
                  <div class="form-group">
                    <label>{{ 'telco-customer-info.customerBranch' | translate }}:</label>
                    <p>{{list.customerBranch || " -- "}}</p>
                  </div>
                </div>

                <div class="col-md-6 col-lg-6" *ngIf="list.customerDepartment">
                  <div class="form-group">
                    <label>{{ 'telco-customer-info.customerDepartment' | translate }}:</label>
                    <p>{{list.customerDepartment || " -- "}}</p>
                  </div>
                </div>

                <div class="col-md-12 col-lg-12">
                  <div class="form-group">
                    <label>{{ 'telco-customer-info.primaryAddress' | translate }}:</label>
                    <p>{{list.primaryAddress || " -- "}}</p>
                  </div>
                </div>


                <div class="identity-proof-details col-md-3 col-lg-3">
                  <p class="identity-proof-title">{{ 'telco-customer-info.buildingProof' | translate }}:</p>
                  <div class="row identity-proof-form-details">
                    <div class=" identity-proof-form">
                      <div class="proof-images" *ngIf="list.buildingProof != ''">
                        <div class="image">
                          <p-image src="{{list.buildingProof}}" alt="Image" [preview]="true"></p-image>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="identity-proof-details col-md-3 col-lg-3">
                  <p class="identity-proof-title">{{ 'telco-customer-info.identityProof' | translate }}:</p>
                  <div class="row identity-proof-form-details">
                    <div class=" identity-proof-form">
                      <div class="proof-images" *ngIf="list.identityProof != ''">
                        <div class="image">
                          <p-image src="{{list.identityProof}}" alt="Image" [preview]="true"></p-image>

                          <!-- <img src="{{list.identityProof}}" (click)="imageUrlSelect(list.identityProof)" alt=""> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="identity-proof-details col-md-3 col-lg-3">
                  <p class="identity-proof-title">{{ 'telco-customer-info.photoProof' | translate }}:</p>
                  <div class="row identity-proof-form-details">
                    <div class=" identity-proof-form">
                      <div class="proof-images" *ngIf="list.photoProof != ''">
                        <div class="image">
                          <p-image src="{{list.photoProof}}" alt="Image" [preview]="true"></p-image>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="identity-proof-details col-md-3 col-lg-3">
                  <p class="identity-proof-title">{{ 'telco-customer-info.addressProof' | translate }}:</p>
                  <div class="row identity-proof-form-details">
                    <div class=" identity-proof-form">
                      <div class="proof-images" *ngIf="list.addressProof != ''">
                        <div class="image">
                          <p-image src="{{list.addressProof}}" alt="Image" [preview]="true"></p-image>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>

            <hr />

            <!-- Service Info -->
            <h3 class="title-header">{{ 'telco-customer-info.serviceInfo' | translate }} </h3>
            <div class="section">

              <div *ngFor="let service of list.serviceInfo; let i = index" class="nested-group">

                <div class="row">
                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>{{ 'telco-customer-info.serviceId' | translate }}:</label>
                      <p>{{service.serviceId || " -- "}}</p>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>{{ 'telco-customer-info.serviceStatus' | translate }}:</label>
                      <p>{{service.serviceStatus || " -- "}}</p>
                    </div>
                  </div>


                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>{{ 'telco-customer-info.serviceName' | translate }}:</label>
                      <p>{{service.serviceName || " -- "}}</p>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>{{ 'telco-customer-info.serviceInfo' | translate }}:</label>
                      <p>{{service.serviceInfo || " -- "}}</p>

                    </div>
                  </div>

                  <!-- <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Asset:</label>
                      <p>{{service.assetName || " -- "}}</p>

                    </div>
                  </div> -->

                  <div class="col-md-12 col-lg-12">
                    <div class="status-table">
                      <table class="table">
                        <thead>
                          <tr>
                            <th style="width: 30%;">{{ 'telco-customer-info.assetId' | translate }}</th>
                            <th style="width: 70%;text-align: center;">{{ 'telco-customer-info.asset' | translate }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let list of service.assetDetails">
                            <td style="width: 30%;">{{list.assetId}}</td>
                            <td style="width: 70%;text-align: center;">{{list.assetName}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                </div>


                <!-- SIP Info -->
                <div class="sub-section" *ngIf="service.sipInfo && service.sipInfo != null && service.sipInfo != ''">
                  <h5>{{ 'telco-customer-info.sipInfo' | translate }}</h5>
                  <div *ngFor="let sip of service.sipInfo; let j = index;let last = last">


                    <div class="row">
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>{{ 'telco-customer-info.sipName' | translate }}:</label>

                          <p>{{sip.sipName || " -- "}}</p>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>{{ 'telco-customer-info.sipValue' | translate }}:</label>
                          <p>{{sip.sipValue || " -- "}}</p>
                        </div>
                      </div>

                    </div>
                    <hr *ngIf="!last">
                  </div>
                </div>

                <!-- DIP Info -->
                <div class="sub-section" *ngIf="service.dipInfo && service.dipInfo != null && service.dipInfo != ''">
                  <h5>{{ 'telco-customer-info.dipInfo' | translate }} </h5>
                  <div *ngFor="let dip of service.dipInfo; let j = index;let last = last">
                    <div class="row">
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>{{ 'telco-customer-info.dipName' | translate }}:</label>
                          <p>{{dip.dipName || " -- "}}</p>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>{{ 'telco-customer-info.dipValue' | translate }}:</label>
                          <p>{{dip.dipValue || " -- "}}</p>
                        </div>
                      </div>
                    </div>
                    <hr *ngIf="!last">
                  </div>
                </div>

                <!-- Dealer Info -->
                <div class="sub-section"
                  *ngIf="service.dealerInfo && service.dealerInfo != null && service.dealerInfo != ''">
                  <h5>{{ 'telco-customer-info.dealerInfo' | translate }} </h5>
                  <div *ngFor="let dealer of service.dealerInfo; let j = index;let last = last">
                    <div class="row">
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>{{ 'telco-customer-info.dealerName' | translate }}:</label>

                          <p>{{dealer.dealerName || " -- "}}</p>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                          <label>{{ 'telco-customer-info.dealerLocation' | translate }}:</label>

                          <p>{{dealer.dealerLocation || " -- "}}</p>
                        </div>
                      </div>
                    </div>
                    <hr *ngIf="!last">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeViewModal" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' |
            translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>



<button style="display: none;" id="view-object" data-toggle="modal" data-target="#viewObjectModal"></button>

<div class="modal fade" id="viewObjectModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'object-info.headings.detail' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="form-group" *ngFor="let viewData of singleObjectInfoData">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.objectInfoId' | translate }} :</label>
              <p>{{viewData.objectInfoId || '--'}}</p>
            </div>
            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.name' | translate }} :</label>
              <p>{{viewData.name || '--'}}</p>
            </div>
            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.givenName' | translate }} :</label>
              <p>{{viewData.givenName || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.serialNumberCheckBox">
              <label>{{ 'object-info.serialNumber' | translate }} :</label>
              <p>{{viewData.serialNumber || '--'}}</p>
            </div>
            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.group' | translate }} :</label>
              <p>{{viewData.group || '--'}}</p>
            </div>
            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.type' | translate }} :</label>
              <p>{{viewData.type || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.modelCheckBox">
              <label>{{ 'object-info.model' | translate }} :</label>
              <p>{{viewData.model || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.makeCheckBox">
              <label>{{ 'object-info.make' | translate }} :</label>
              <p>{{viewData.make || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.objectCondition' | translate }} :</label>
              <p>{{viewData.objectCondition || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'telco-customer-info.assetStatus' | translate }} :</label>
              <p>{{viewData.assetStatus || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.originalCostCheckBox">
              <label>{{ 'object-info.originalCost' | translate }} :</label>
              <p>{{viewData.originalCost || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.currentCostCheckBox">
              <label>{{ 'object-info.currentCost' | translate }} :</label>
              <p>{{viewData.currentCost || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.branchCheckBox">
              <label>{{ 'object-info.branch' | translate }} :</label>
              <p>{{viewData.branch || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.departmentCheckBox">
              <label>{{ 'object-info.department' | translate }} :</label>
              <p>{{viewData.department || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.location' | translate }} :</label>
              <p>{{viewData.location || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.country' | translate }} :</label>
              <p>{{viewData.country || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.provinceOrState' | translate }} :</label>
              <p>{{viewData.provinceOrState || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.zone' | translate }} :</label>
              <p>{{viewData.zone || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.postalCode' | translate }} :</label>
              <p>{{viewData.postalCode || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.city' | translate }} :</label>
              <p>{{viewData.city || '--'}}</p>
            </div>


            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.createdDate' | translate }} :</label>
              <p>{{viewData.createdDate | date}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.acquisitionDate' | translate }} :</label>
              <p>{{viewData.acquisitionDate || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.depreciationCheckbox">
              <label>{{ 'object-info.salvageValue' | translate }} :</label>
              <p>{{viewData.salvageValue || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.depreciationCheckbox">
              <label>{{ 'object-info.depreciationMethod' | translate }} :</label>
              <p>{{viewData.depreciationMethod || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="viewData.departmentCheckBox">
              <label>{{ 'object-info.assetLifeNumber' | translate }} :</label>
              <p>{{viewData.assetLifeNumber || '--'}}</p>
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'object-info.asset_Category' | translate }} :</label>
              <p>{{viewData.asset_Category || '--'}}</p>
            </div>
            <div class="col-md-12 col-lg-12 qr-code">
              <label>{{ 'object-info.qr_code' | translate }} :</label>
              <qrcode [qrdata]="jsonString" [width]="150" [errorCorrectionLevel]="'M'"></qrcode>
            </div>


            <div class="col-md-12 col-lg-12">
              <div class="image-container" style="margin-top: 20px;">
                <div class="image-header image-header1">
                  <h5>{{ 'object-info.images' | translate }}</h5>
                </div>


                <div class="image-content-block">
                  <div class="image-single" *ngFor="let image of viewData.imagesWithDetails;let i = index">
                    <p>{{image.name}}</p>
                    <img src="{{image.image}}" alt="">
                  </div>
                </div>



              </div>
            </div>

            <div class="col-md-12 col-lg-12" *ngIf="viewData.nameValue && viewData.nameValue.length != 0">
              <h5 class="data-list-title">{{ 'object-info.nameValue' | translate }}</h5>
            </div>

            <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.nameValue && viewData.nameValue.length != 0">

              <div class="list-block">
                <ul class="ui-tree">
                  <ng-container *ngFor="let item of viewData.nameValue">
                    <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: item }"></ng-container>
                  </ng-container>
                </ul>

                <ng-template #renderNode let-node>
                  <li>
                    <strong>{{ node.key }}:</strong> {{ node.value }}
                    <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                      <ng-container *ngFor="let child of node.keyValue">
                        <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: child }"></ng-container>
                      </ng-container>
                    </ul>
                  </li>
                </ng-template>
              </div>
            </div>

            <div class="col-md-12 col-lg-12"
              *ngIf="viewData.performanceMatrix && viewData.performanceMatrix.length != 0">
              <h5 class="data-list-title">{{ 'object-info.performanceMatrix' | translate }} </h5>
            </div>


            <div class="col-md-12 col-lg-12" *ngIf="viewData.warranty">
              <h5 class="data-list-title">{{ 'object-info.warranty' | translate }}</h5>
            </div>

            <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.warranty">
              <div class="list-block">
                <ul class="ui-tree">
                  <li *ngFor="let warrantyInfo of viewData.warrantyInfo">
                    <strong>{{ warrantyInfo.key }}:</strong> {{ warrantyInfo.value }}
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-md-12 col-lg-12" *ngIf="viewData.purchase">
              <h5 class="data-list-title">{{ 'object-info.purchase' | translate }}</h5>
            </div>

            <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.purchase">
              <div class="list-block">
                <ul class="ui-tree">
                  <li *ngFor="let purchaseInfo of viewData.purchaseInfo">
                    <strong>{{ purchaseInfo.key }}:</strong> {{ purchaseInfo.value }}
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-md-12 col-lg-12 data-list"
              *ngIf="viewData.performanceMatrix && viewData.performanceMatrix.length != 0">

              <div class="list-block">
                <ul class="ui-tree">
                  <ng-container *ngFor="let item of viewData.performanceMatrix">
                    <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: item }"></ng-container>
                  </ng-container>
                </ul>

                <ng-template #renderNode1 let-node>
                  <li>
                    <strong>{{ node.key }}:</strong> {{ node.value }}
                    <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                      <ng-container *ngFor="let child of node.keyValue">
                        <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: child }"></ng-container>
                      </ng-container>
                    </ul>
                  </li>
                </ng-template>
              </div>
            </div>



            <div class="col-md-12 col-lg-12" style="padding: 0;"
              *ngIf="viewData.repairInfos && viewData.repairInfos.length != 0">
              <h5 class="repair-list-title">{{ 'object-info.repairList' | translate }}</h5>




              <div class="repair-list-block">
                <div class="list" *ngFor="let list of viewData.repairInfos">
                  <div>
                    <p><label>{{ 'object-info.repairDone' | translate }} :</label> {{list.description || '--'}}</p>
                  </div>

                  <div class="dates">
                    <p><label>{{ 'object-info.repairGivenTo' | translate }} :</label> {{list.repairGivenTo || '--'}}</p>
                    <p><label>{{ 'object-info.userName' | translate }} :</label> {{list.userName || '--'}}</p>
                    <p><label>{{ 'object-info.phNo' | translate }} :</label> {{list.phNo || '--'}}</p>
                    <p><label>{{ 'object-info.emailId' | translate }} :</label> {{list.emailId || '--'}}</p>
                    <p><label>{{ 'object-info.repairGivenDate' | translate }} :</label> {{list.repairGivenDate | date}}
                    </p>
                    <p><label>{{ 'object-info.repairExpectedEndDate' | translate }} :</label>
                      {{list.repairExpectedEndDate | date}}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12 col-lg-12" style="padding: 0;"
              *ngIf="viewData.assetHealth && viewData.assetHealth.length != 0">
              <h5 class="repair-list-title">{{ 'object-info.connections' | translate }}</h5>

              <div class="row">
                <div class="col-md-6 col-lg-6">
                  <label>{{ 'object-info.assetMonitoringFrequency' | translate }} :</label>
                  <p>{{viewData.assetMonitoringFrequency || '--'}}</p>
                </div>

                <div class="col-md-6 col-lg-6">
                  <label>{{ 'object-info.assetMonitoringTimeSpan' | translate }} :</label>
                  <p>{{viewData.assetMonitoringTimeSpan || '--'}}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 col-lg-6" *ngFor="let connectionDetails of viewData.connectionDetails">
                  <label>{{connectionDetails.key || '--'}} :</label>
                  <p>{{connectionDetails.value || '--'}}</p>
                </div>
              </div>
            </div>



            <div class="col-md-12 col-lg-12" style="padding: 0;"
              *ngIf="viewData.assetHealth && viewData.assetHealth.length != 0">
              <h5 class="repair-list-title">{{ 'object-info.assetHealth' | translate }}</h5>

              <div class="row">
                <div class="col-md-6 col-lg-6" *ngFor="let assetHealthList of viewData.assetHealth">
                  <label>{{assetHealthList.key || '--'}} :</label>
                  <p>{{assetHealthList.value || '--'}}</p>
                </div>
              </div>
            </div>



            <div class="nameValue" *ngIf="viewData.performance">
              <div>
                <h5 class="multi-title">{{ 'object-info.assetPerformance' | translate }}</h5>

                <div class="row keys-content">

                  <div class="col-md-12 col-lg-12 keysBlock">
                    <div class="form-group">
                      <label for="">{{ 'object-info.timeSpan' | translate }}</label>
                      <p>{{viewData.assetPerformance?.timeSpan}}</p>

                    </div>

                    <div class="form-group">
                      <label for="">{{ 'object-info.uom' | translate }}</label>
                      <p>{{viewData.assetPerformance?.uom || '--'}}</p>
                    </div>

                    <div class="form-group">
                      <label for="">{{ 'object-info.expectedOutput' | translate }}</label>
                      <p>{{viewData.assetPerformance?.expectedOutput || '--'}}</p>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12 col-lg-12" style="padding: 0;" *ngIf="viewData.tags && viewData.tags.length != 0">
              <h5 class="repair-list-title">{{ 'object-info.tags' | translate }}</h5>
              <div class="tag-list">
                <p class="tag" *ngFor="let list of viewData.tags">{{list}}</p>
              </div>
            </div>

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">{{
            'generic.cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>